// Select all elements with the specified class
var labelElements = document.querySelectorAll('.checkout-login_tabs label.gt-tab-mob');

// Loop through each element and attach a click event listener
labelElements.forEach(function (element) {
  element.addEventListener('click', function () {
    // Your event handler code here
    enablePopTab(element);
  });
});

function enablePopTab(ele) {
  if (ele) {
    var id = ele.getAttribute('data-id');
    let parentEle = ele.parentElement;
    // Get all children elements of the parent
    let childrens = parentEle.children;
    // Loop through each child element
    for (var i = 0; i < childrens.length; i++) {
      // Set the display property to block
      childrens[i].classList.remove('active');
    }

    ele.classList.add('active');
    parentEle.querySelector('[data-content="' + id + '"]').classList.add('active');
  }
}

function getTotalReviewCount(productId, elementSelector) {
  const url =
    'https://api-cdn.yotpo.com/v1/widget/7Gmb14VMVXAEYwRN2qxcppn3t5AP0r2lVdvyyHky/products/' +
    productId +
    '/reviews.json';
  const options = {
    method: 'GET',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  };

  return fetch(url, options)
    .then((res) => res.json())
    .then((json) => {
      const totalReviews = json.response.bottomline.total_review;
      if (totalReviews && reviewElementSelector) {
        const element = document.querySelector(elementSelector);
        if (element) {
          element.classList.remove('hidden');
        }
      }
      return totalReviews;
    })
    .catch((err) => {
      console.error('Error fetching review count:', err);
      return 0; // Return 0 in case of error
    });
}

const productId = ShopifyAnalytics.meta.product.id;
const reviewElementSelector = '.product__accordion.accordion.reviews.hidden';
if (productId) {
  getTotalReviewCount(productId, reviewElementSelector).then((totalReviews) => { });
}
